import React from 'react';

import {
  ModalDialog,
  Typography
} from 'e100-react-components';

import { useIntl } from 'react-intl';
import { useIsDeletingFavouritStationsLoading } from 'entities/stations';

export const FavouriteStationsDeleteModal = ({
  open = false,
  onCancel,
  onOk
}: FavouriteStationsDeleteModalProps) => {
  const { formatMessage } = useIntl();
  const isDeletingFavouritStationsLoading = useIsDeletingFavouritStationsLoading();

  return (
    <ModalDialog
      open={open}
      title={formatMessage({ id: 'deleteFromFavorites' })}
      labelOk={formatMessage({ id: 'delete' })}
      onOk={onOk}
      labelCancel={formatMessage({ id: 'feedbackModal.cancel' })}
      onClose={onCancel}
      fullWidth
      maxWidth={'sm'}
      isLoading={isDeletingFavouritStationsLoading}
    >
      <Typography>{formatMessage({ id: 'favouriteStations.deleteModal.message' })}</Typography>
    </ModalDialog>
  );
};

interface FavouriteStationsDeleteModalProps {
  open?: boolean;
  onCancel?: () => void;
  onOk?: () => void;
}
